/* unplugin-vue-components disabled */import script from "./indexfj.vue?vue&type=script&setup=true&lang=js"
export * from "./indexfj.vue?vue&type=script&setup=true&lang=js"

import "./indexfj.vue?vue&type=style&index=0&id=2d488a78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d488a78"]])

export default __exports__